export default async function fetcher(url: string) {
  const r = await fetch(url);
  return r.json();
}
